export default __webpack_public_path__ + "static/media/itisaboutpeople.c6c8ec80.jpg";